import Container, { IProps as IPlayerProps } from './player';
import PlayerUser from './player-user';
import PlayerCards from './player-cards';
import PlayerActions from './player-actions';
interface IPlayerComponent {
  // eslint-disable-next-line no-unused-vars
  (Props: IPlayerProps): JSX.Element;
  User: () => JSX.Element;
  Cards: () => JSX.Element;
  Actions: () => JSX.Element;
}

const Player: IPlayerComponent = Object.assign(Container, {
  User: PlayerUser,
  Cards: PlayerCards,
  Actions: PlayerActions,
});

export default Player;
